<template>
  <div class="table-wrapper">
    <table>
      <tr>
        <th v-if="!isMobile" />
        <th
          v-for="(column, index) in tableData.header.slice(1)"
          :key="index"
          class="heading"
        >
          <div>{{ column }}</div>
          <div
            v-if="headerImagesClasses.length"
            :class="['card', headerImagesClasses[`${index}`]]"
          />
        </th>
      </tr>

      <template v-if="!isMobile">
        <tr
          v-for="(row, rowIndex) in tableData.rows"
          :key="rowIndex"
          class="table-row"
        >
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            v-dompurify-html="cell"
            class="cell"
          />
        </tr>
      </template>

      <template v-else>
        <template v-for="(row, rowIndex) in tableData.rows">
          <tr :key="rowIndex">
            <td
              v-dompurify-html="row[0]"
              class="title"
              :colspan="tableData.header.length - 1"
            />
          </tr>
          <tr :key="rowIndex">
            <td
              v-for="(cell, cellIndex) in row.slice(1)"
              :key="cellIndex"
              v-dompurify-html="cell"
            />
          </tr>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      tableData: {
        type: Array,
        default: () => []
      },
      headerImagesClasses: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      ...mapGetters('device', [
        'isMobile'
      ])
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  table {
    width: 100%;
    white-space: pre-line;

    @include bp-mf-tablet {
      margin: 50px 0 40px;
    }
  }

  td, th {
    width: 33%;
    height: 52px;
    padding: 18px 3px;
    text-align: center;
    line-height: 20px;
    font-size: em(12);

    @include bp-mf-tablet {
      width: 100%;
      height: 72px;
    }
  }

  .heading {
    font-weight: 500;

    @include bp-mf-tablet {
      font-size: em(16);
    }
  }

  .table-row {
    border-top: 1px solid $grey-border;

    &:last-child {
      border-bottom: 1px solid $grey-border;
    }

    .cell {

      &:first-child {
        font-weight: 500;
      }
    }
  }

  .title {
    background: $table-gray-background;
    border-top: 1px solid $grey-border;
    font-weight: 500;
  }

  .card {
    display: block;
    max-width: 100px;
    min-width: 87px;
    height: 62px;
    margin: 4px auto 0;
    background-repeat: no-repeat;

    @include bp-mf-tablet {
      width: 170px;
      max-width: 170px;
      height: 101px;
    }

    &.BASIC {
      background-image: url("~assets/images/pins/BASIC.png");
      background-size: contain;
    }

    &.EX {
      background-image: url("~assets/images/pins/EX.png");
      background-size: contain;
    }

    &.VIP {
      background-image: url("~assets/images/pins/VIP.png");
      background-size: contain;
    }
  }

</style>
